module.exports = __webpack_public_path__ + "01_long_gold.5b0e7cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_long_gold.png
// module id = kM4r
// module chunks = 0